import {
  accountVuexStore,
  appVuexStore,
  cartVuexStore,
  cartSettingsVuexStore,
  globalBannerVuexStore,
  loginModalVuexStore,
  mainNavVuexStore,
  newsletterBlocksVuexStore,
  pageVuexStore,
  returnFormVuexStore,
  searchVuexStore,
  toastVuexStore 
} from "#imports"
const VuexStore = {
  modules: {
      'account': {
        ...accountVuexStore.default ?? accountVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'app': {
        ...appVuexStore.default ?? appVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'cart': {
        ...cartVuexStore.default ?? cartVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'cartSettings': {
        ...cartSettingsVuexStore.default ?? cartSettingsVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'globalBanner': {
        ...globalBannerVuexStore.default ?? globalBannerVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'loginModal': {
        ...loginModalVuexStore.default ?? loginModalVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'mainNav': {
        ...mainNavVuexStore.default ?? mainNavVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'newsletterBlocks': {
        ...newsletterBlocksVuexStore.default ?? newsletterBlocksVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'page': {
        ...pageVuexStore.default ?? pageVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'returnForm': {
        ...returnFormVuexStore.default ?? returnFormVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'search': {
        ...searchVuexStore.default ?? searchVuexStore,
        namespaced: true,
        modules: {},
      }
    ,
      'toast': {
        ...toastVuexStore.default ?? toastVuexStore,
        namespaced: true,
        modules: {},
      }
    }, 
  }
export default VuexStore